export default class ChartStyle {
    bar;
    line;
    horizontal;
    constructor() {
        this.bar = {
            options: {
                theme: {
                    mode: 'dark', 
                },
                chart: {
                    background: 'transparent',
                    id: 'bar-chart',  
                    toolbar: {
                        show: false,
                    },
                },
                xaxis: {
                    categories: ["MAR"],
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                legend: {
                    show: false
                },
                colors: ['#9723ff'],
                grid: {
                    borderColor: "#3F4254",
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 10,
                        rangeBarOverlap: false,
                        columnWidth: ['40%'],
                    },
                },
                dataLabels: {
                    enabled: false
                },
            },
            series: [{
                name: 'Quote value: ',
                data: [0]
            }]
        };
        this.line = {
            options: {
                theme: {
                    mode: 'dark', 
                },
                chart: {
                    background: 'transparent',
                    id: 'line-chart',  
                    toolbar: {
                        show: false,
                    },
                },
                xaxis: {
                    categories: ["MAR"],
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                legend: {
                    show: false
                },
                colors: ['#fefc01'],
                grid: {
                    borderColor: "#3F4254",
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 10,
                        rangeBarOverlap: false,
                        columnWidth: ['40%'],
                    },
                },
                dataLabels: {
                    enabled: false
                },
            },
            series: [{
                name: 'VALUE',
                data: [0]
            }]
        };
        this.horizontal = {
            options: {
                theme: {
                    mode: 'dark', 
                },
                chart: {
                    background: 'transparent',
                    id: 'horizontal-chart',  
                    toolbar: {
                    show: false,
                    },
                },
                xaxis: {
                    categories: ["VALUE"],
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                legend: {
                    show: true
                },
                colors: ['#01fd01'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 10,
                        rangeBarOverlap: false,
                        columnWidth: ['40%'],
                    },
                },
                grid: {
                    borderColor: "#3F4254",
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                dataLabels: {
                    enabled: false
                },
            },
            series: [{
                name: 'VALUE',
                data: [0]
            }]
        },
        
        this.invoiced = {
            options: {
                theme: {
                    mode: 'dark', 
                },
                chart: {
                    background: 'transparent',
                    id: 'invoiced-chart',  
                    toolbar: {
                    show: false,
                    },
                },
                xaxis: {
                    categories: ["VALUE"],
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: true,
                        color: '#3F4254',
                    }
                },
                legend: {
                    show: true
                },
                colors: ['#00ffff'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 10,
                        rangeBarOverlap: false,
                        columnWidth: ['40%'],
                    },
                },
                grid: {
                    borderColor: "#3F4254",
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                dataLabels: {
                    enabled: false
                },
            },
            series: [{
                name: 'VALUE',
                data: [0]
            }]
        };
    }
}